import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  resetePasswordRequestFailure,
  resetPasswordRequestStart,
  resetPasswordRequestSuccess,
} from "../../store/features/resetPassword/resetPasswordRequestSlice";
import { API_BASE_URL, defaultAxiosConfig, parseApiError } from "../utils";

const ENDPOINT = "/api/v1/user/reset-password-request/";

const resetPasswordRequestApi = async ({ email }) => {
  const response = await axios.post(
    `${API_BASE_URL}${ENDPOINT}`,
    { email },
    defaultAxiosConfig
  );
  return response.data;
};

function* handleResetPasswordRequestSaga(action) {
  try {
    const data = yield call(resetPasswordRequestApi, action.payload);
    yield put(resetPasswordRequestSuccess(data));
  } catch (error) {
    const errorMessage = parseApiError(error);
    yield put(resetePasswordRequestFailure(errorMessage));
  }
}

export default function* resetPasswordRequestSaga() {
  yield takeLatest(
    resetPasswordRequestStart.type,
    handleResetPasswordRequestSaga
  );
}
